import { AppProviders } from "./components/routing/AppProviders";
import { MainRoutes } from "./components/routing/MainRoutes";
import { HelmetProvider } from "react-helmet-async";
import { FaviconManager } from "./components/layout/FaviconManager";
import { SponsorAdModal } from "./components/music/SponsorAdModal";
import { GlobalWhatsAppPolicyGate } from "./components/auth/GlobalWhatsAppPolicyGate";
import { OverlayProvider } from "./contexts/OverlayContext";
import "./App.css";

function App() {
  return (
    <HelmetProvider>
      <OverlayProvider>
        <AppProviders>
          <FaviconManager />
          <SponsorAdModal />
          <GlobalWhatsAppPolicyGate>
            <MainRoutes />
          </GlobalWhatsAppPolicyGate>
        </AppProviders>
      </OverlayProvider>
    </HelmetProvider>
  );
}

export default App;
